/**
 * @generated SignedSource<<44d3e3fbfb64110c0f6bf5cf81301d03>>
 * @relayHash 6934e7e820f602be48877c054f497a7a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 222da0ddb1a60f8817ddc5fc12760bbcf803794535fce1b0f36e9ff571f0a397

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ui_jiraCalendarQuery } from './ui_jiraCalendarQuery.graphql';

const node: PreloadableConcreteRequest<ui_jiraCalendarQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "222da0ddb1a60f8817ddc5fc12760bbcf803794535fce1b0f36e9ff571f0a397",
    "metadata": {},
    "name": "ui_jiraCalendarQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
